import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import uuid from 'uuid/v1';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Stack,
  FormControl,
  InputLabel,
  Select,
  Button,
  TextField,
  Card,
  CardMedia,
  Tooltip,
  Typography,
  MenuItem,
  Box,
  IconButton,
  FormGroup,
  FormControlLabel,
  Switch
} from '@mui/material';
import { isEmpty, find, isEqual, cloneDeep, map, filter } from 'lodash';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import Loading from '../../Loading/index';
import handleErrorInClient from '../../../../modules/handle-error-in-client';
import UploadFileComponent from '../../UploadFileComponent/UploadFileComponent';

import * as templateOps from '../../../../api/AnnotationTemplates/annotation-template-operations';

import OpenModalFromUrl from '../../OpenModalFromUrl/index';
import TablePagination from '../../TablePagination/index';

import CenterMap from '../../CenterMap';

import loadCSVFromURL from '../../../../modules/load-csv-from-url';

const MultipleButtonItem = ({
  elementItem,
  updateAnnotationFields,
  updatedAnnotation,
  isAdvancedMode
}) => {
  const [multiButtonList, setMultiButtonList] = React.useState(
    templateOps.getElementMultiValues(elementItem)
  );
  const [multiButtonSelect, setMultiButtonSelect] = React.useState({});
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 7;
  const totalCount = multiButtonList.length;
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const startButtonToShow = filter(multiButtonList, (element, index) => index < itemsPerPage);
  const [buttonsToShow, setButtonsToShow] = React.useState(startButtonToShow);
  const [functionsList, setFunctionsList] = React.useState([]);

  const [functionSelected, setFunctionSelected] = React.useState({});
  const [selectUrlImg, setSelectUrlImg] = React.useState('');
  const [isUpdate, setIsUpdate] = React.useState(false);

  const [heightIframe, setHeightIframe] = React.useState('300');
  const [openFullScreen, setOpenFullScreen] = React.useState(false);
  const [modeViewOnlyFullScreen, setModeViewOnlyFullScreen] = React.useState(false);
  const [centerMapValues, setCenterMapValues] = React.useState({ mode: 'none', coords: [] });
  const textButton = isUpdate ? 'update button' : 'add button';
  const [isLoading, setIsLoading] = React.useState(false);
  const [showIframe, setShowIframe] = React.useState(false);

  const changePage = pageNumber => {
    const indexFilter = itemsPerPage * pageNumber;
    const prevIndexFilter = itemsPerPage * (pageNumber - 1);
    const newDatasToShow = filter(
      multiButtonList,
      (element, index) => index >= prevIndexFilter && index < indexFilter
    );
    setButtonsToShow(newDatasToShow);
    setCurrentPage(pageNumber);
  };

  const handleLinkUpload = imgUrl => {
    setSelectUrlImg(imgUrl);
    const existButton = find(multiButtonList, image => isEqual(image.url, imgUrl));
    if (!isEmpty(existButton)) {
      setIsUpdate(true);
    } else {
      setIsUpdate(false);
    }
  };

  const addButtonList = () => {
    const existButton = !isEmpty(
      find(multiButtonList, button => isEqual(button.name, functionSelected.name))
    );
    if (!existButton && !isUpdate) {
      const newButton = {
        url: functionSelected.html,
        name: functionSelected.name,
        imgLink: selectUrlImg,
        onlyFullScreen: modeViewOnlyFullScreen,
        height: heightIframe,
        functionSelected,
        centerMode: centerMapValues.mode,
        coordsCenter: centerMapValues.coords
      };
      setMultiButtonList([...multiButtonList, newButton]);
      updateAnnotationFields(elementItem, 'multiValues', [...multiButtonList, newButton]);
    }
    if (existButton && !isUpdate) {
      Bert.alert('El boton ya está añadido', 'danger');
    }
    if (isUpdate) {
      const updateButtonsList = map(multiButtonList, button => {
        const buttonClone = cloneDeep(button);
        if (isEqual(button.name, functionSelected.name)) {
          buttonClone.url = functionSelected.html;
          buttonClone.imgLink = selectUrlImg;
          buttonClone.name = functionSelected.name;
          buttonClone.onlyFullScreen = modeViewOnlyFullScreen;
          buttonClone.height = heightIframe;
          buttonClone.functionSelected = functionSelected;
          buttonClone.centerMode = centerMapValues.mode;
          buttonClone.coordsCenter = centerMapValues.coords;
        }
        return buttonClone;
      });
      setMultiButtonList(updateButtonsList);
      updateAnnotationFields(elementItem, 'multiValues', updateButtonsList);
      Bert.alert('Update successfuly', 'success');
    }
  };

  const deleteButtonList = func => {
    const cloneList = cloneDeep(multiButtonList);
    const index = multiButtonList.indexOf(
      find(multiButtonList, element => isEqual(element.name, func.name))
    );
    cloneList.splice(index, 1);
    setMultiButtonList(cloneList);
    setIsUpdate(false);
    updateAnnotationFields(elementItem, 'multiValues', cloneList);
  };

  const handleSelectButtonList = value => {
    const newSelectButton = find(multiButtonList, button => isEqual(button.name, value));
    const newImgLink = !isEmpty(newSelectButton) ? newSelectButton.imgLink : '';
    const newFunctionValue = !isEmpty(newSelectButton) ? newSelectButton.functionSelected : 'none';
    const newHeightValue = !isEmpty(newSelectButton) ? newSelectButton.height : '300';
    const newOnlyFullScreen = !isEmpty(newSelectButton) ? newSelectButton.onlyFullScreen : false;
    setSelectUrlImg(newImgLink);
    setFunctionSelected(newFunctionValue);
    setHeightIframe(newHeightValue);
    setModeViewOnlyFullScreen(newOnlyFullScreen);
    if (!isEmpty(newSelectButton)) setMultiButtonSelect(newSelectButton);
    if (value !== 'none') setIsUpdate(true);
    else setIsUpdate(false);
  };

  const callBackFunctions = async () => {
    try {
      const response = await fetch('https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/jupyter', {
        method: 'POST',
        body: JSON.stringify({
          get_functions: true
        }),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      const answer = await response.json();
      if (!isEmpty(answer)) {
        const functionsArray = answer.functions;
        setFunctionsList(functionsArray);
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const handleFunctionSelected = async functionItem => {
    const newFunctionSelect = !isEqual(functionItem, 'none')
      ? find(functionsList, func => isEqual(func.name, functionItem))
      : {};
    setFunctionSelected(newFunctionSelect);
    if (!isEmpty(newFunctionSelect) && !isEqual(newFunctionSelect.name, multiButtonSelect.name))
      setIsUpdate(false);
  };

  const exportCsvExample = button => {
    const funcButton = button.functionSelected;
    fetch(funcButton.csv)
      .then(data => data.blob())
      .then(blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = funcButton.csv;
        link.click();
      })
      .catch(console.error);
  };

  const importCsv = async (item, isFullScreen) => {
    const handleFileImportCSV = async (event, itemProp, fullScreen) => {
      setIsLoading(true);
      setShowIframe(false);
      const file = event.target.files[0];

      if (!isEmpty(file)) {
        Bert.alert('Selecciona un archivo primero', 'danger');
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('disc', 'data3');

      try {
        const response = await fetch('https://sd1.d3.ipsilum.com/upload', {
          method: 'POST',
          body: formData,
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        });
        const respuesta = await response.json();
        if (!isEmpty(response)) {
          if (response.status !== 'OK') {
            Bert.alert('Ha habido un problema al cargar el archivo', 'danger');
            return;
          }
        }
        const urlFile = respuesta.data.link;

        const responseScript = await fetch(
          'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/jupyter',
          {
            method: 'POST',
            body: JSON.stringify({
              execute_function: itemProp.functionSelected.script,
              csv_config: urlFile,
              html_process: itemProp.functionSelected.html
            }),
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
            credentials: 'omit',
            referrerPolicy: 'no-referrer'
          }
        );
        const answerScript = await responseScript.json();
        if (!isEmpty(answerScript)) {
          if (answerScript.status === 'OK') {
            const newFunction = cloneDeep(item.functionSelected);
            newFunction.html = answerScript.data;
            setFunctionSelected(newFunction);
            if (fullScreen) setOpenFullScreen(true);
            else setShowIframe(true);
          }
        }
      } catch (error) {
        handleErrorInClient(error);
      }
      setIsLoading(false);
    };
    if (!isEmpty(item)) {
      if (!isEqual(item.centerMode, 'none')) {
        if (!isEmpty(item.coordsCenter)) {
          const a = [40.44823460273213, -3.727787665372283];
          const csvUrl = item.functionSelected.csv;
          const csvAsText = await loadCSVFromURL(csvUrl);
          const headersRow = csvAsText.substring(0, csvAsText.indexOf('\n'));
          if (!headersRow.includes('latitud') && !headersRow.includes('longitud')) {
            Bert.alert('The file of function is not correct', 'danger');
          } else {
            let valuesText = '';
            map(a, coord => {
              valuesText = `${valuesText}${coord},`;
            });
            const newContentCsv = `${headersRow}\n${valuesText}`;
            const blob = new Blob([newContentCsv], { type: 'text/csv' });
            const fileName = `${item.functionSelected.name}`;
            const processedFile = new File([blob], `${fileName}-processed.csv`);
            const newFile = { target: { files: [processedFile] } };
            handleFileImportCSV(newFile, item, isFullScreen);
          }
        } else {
          Bert.alert('The coordinates do not exist', 'danger');
        }
      } else {
        const inputElement = document.createElement('input');
        inputElement.type = 'file';
        inputElement.onchange = event => handleFileImportCSV(event, item, isFullScreen);
        inputElement.click();
      }
    }
  };

  const handleSelectButtonView = async (button, isFullScreen) => {
    if (isEqual(button.name, functionSelected.name)) {
      if (isFullScreen) setOpenFullScreen(true);
      else setShowIframe(!showIframe);
    } else {
      importCsv(button, isFullScreen);
    }
  };

  const renderIconButton = ({ keyProp, onClickProp, iconProp, titleProp, disabledProp }) => {
    return (
      <Tooltip key={uuid()} title={titleProp}>
        <span>
          <IconButton
            key={keyProp}
            onClick={onClickProp}
            size="small"
            disabled={disabledProp}
            style={{
              color: '#2A3F90'
            }}
          >
            {iconProp}
          </IconButton>
        </span>
      </Tooltip>
    );
  };

  React.useEffect(() => {
    if (isAdvancedMode) callBackFunctions();
  }, []);

  return (
    <>
      {!isAdvancedMode && (
        <>
          {!isEmpty(multiButtonList) && (
            <>
              <Stack marginLeft="2%" direction="row" justifyContent="flex-start">
                {buttonsToShow.map(item => {
                  return (
                    <Card
                      key={item.url}
                      alignitems="center"
                      style={{ height: '100px', width: '125px', marginRight: '2%' }}
                    >
                      <Stack direction="row">
                        <Stack direction="column">
                          <Tooltip key={uuid()} title={item.name}>
                            <Button
                              key={uuid()}
                              style={{ padding: 0, height: '100%' }}
                              onClick={() => {
                                handleSelectButtonView(item, modeViewOnlyFullScreen);
                              }}
                            >
                              <CardMedia
                                key={item.imgLink}
                                component="img"
                                height="100"
                                image={item.imgLink}
                                alt={item.name}
                              />
                            </Button>
                          </Tooltip>
                        </Stack>
                        <Stack direction="column">
                          {renderIconButton({
                            keyProp: uuid(),
                            onClickProp: () => exportCsvExample(item),
                            iconProp: <InfoOutlinedIcon />,
                            titleProp: 'info',
                            disabledProp: false
                          })}
                          {renderIconButton({
                            keyProp: uuid(),
                            onClickProp: () => importCsv(item, modeViewOnlyFullScreen),
                            iconProp: <RefreshOutlinedIcon />,
                            titleProp: 'refresh',
                            disabledProp: false
                          })}
                        </Stack>
                      </Stack>
                    </Card>
                  );
                })}
              </Stack>
              <Stack direction="row" display="flex" justifyContent="flex-end" marginTop="2%">
                {totalPages > 1 && (
                  <Typography
                    marginTop="1%"
                    marginRight="1%"
                  >{`${currentPage} - ${totalPages}`}</Typography>
                )}
                <TablePagination
                  currentPage={currentPage}
                  isPaginationOn
                  itemsPerPage={itemsPerPage}
                  stretchView
                  totalCount={totalCount}
                  changePage={changePage}
                />
              </Stack>
              {isLoading && <Loading />}
              {!isEmpty(functionSelected) && !isLoading && showIframe && (
                <Box marginLeft="2%" marginTop="5%">
                  <Stack direction="row" display="flex" justifyContent="flex-start">
                    {renderIconButton({
                      keyProp: uuid(),
                      onClickProp: () => setOpenFullScreen(true),
                      iconProp: <FontAwesomeIcon icon="expand" />,
                      titleProp: 'Full Screen'
                    })}

                    <OpenModalFromUrl
                      isFullScreen
                      isImage={false}
                      openModal={openFullScreen}
                      setOpenModal={setOpenFullScreen}
                      url={functionSelected.html}
                      title={functionSelected.name}
                    />
                  </Stack>
                  <iframe
                    title="iframe"
                    src={functionSelected.html}
                    width="100%"
                    height={`${heightIframe}px`}
                  />
                </Box>
              )}
            </>
          )}
        </>
      )}
      {isAdvancedMode && (
        <>
          <Stack
            direction="row"
            display="flex"
            justifyContent="flex-start"
            width="50%"
            marginTop="2%"
          >
            <TextField
              id="heightIframe"
              label="Height iframe"
              size="small"
              defaultValue={heightIframe}
              onChange={event => setHeightIframe(event.target.value)}
              readOnly={false}
            />
          </Stack>

          <Stack direction="row" marginTop="2%">
            <Stack direction="column" width="60%">
              <Typography>Image Button</Typography>
              <UploadFileComponent
                linkValueProp={selectUrlImg}
                handleValueLink={handleLinkUpload}
              />
              <br />
              <FormControl>
                <InputLabel id="demo-simple-select-label">Function to button</InputLabel>
                <Select
                  style={{ width: '95%' }}
                  size="small"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={!isEmpty(functionSelected) ? functionSelected.name : 'none'}
                  label="Function to button"
                  onChange={event => handleFunctionSelected(event.target.value)}
                >
                  <MenuItem value="none">------</MenuItem>
                  {map(functionsList, item => (
                    <MenuItem key={item.name} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <br />
              <CenterMap
                updatedAnnotation={updatedAnnotation}
                handleCenterMap={(coords, mode) => setCenterMapValues({ mode, coords })}
                widthSelector="95%"
                elementToRender={multiButtonSelect}
              />
            </Stack>
            <Stack direction="column" width="40%">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={modeViewOnlyFullScreen}
                      onChange={() => setModeViewOnlyFullScreen(!modeViewOnlyFullScreen)}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  }
                  label={modeViewOnlyFullScreen ? 'Full Screen' : 'Inside Annotation'}
                />
              </FormGroup>
              <FormControl>
                <InputLabel shrink htmlFor="select-multiple-native">
                  Buttons
                </InputLabel>
                <Select
                  multiple
                  native
                  label="Images"
                  select={!isEqual(multiButtonSelect, 'none') ? multiButtonSelect.name : 'none'}
                  onChange={event => handleSelectButtonList(event.target.value)}
                  inputProps={{
                    id: 'select-multiple-native'
                  }}
                >
                  <option value="none">New...</option>
                  {multiButtonList.map(buttonObject => (
                    <option key={buttonObject.name} value={buttonObject.name}>
                      {buttonObject.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <Stack direction="row" display="flex" justifyContent="flex-end">
                <Button
                  disabled={isEmpty(functionSelected)}
                  onClick={() => addButtonList()}
                  variant="outlined"
                  color="success"
                  size="small"
                >
                  {textButton}
                </Button>
                <Button
                  disabled={isEmpty(functionSelected)}
                  onClick={() => deleteButtonList(functionSelected)}
                  variant="outlined"
                  color="error"
                  size="small"
                >
                  remove button
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </>
      )}
    </>
  );
};

MultipleButtonItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update'),
  updatedAnnotation: {}
};

MultipleButtonItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  updatedAnnotation: PropTypes.object,
  isAdvancedMode: PropTypes.bool.isRequired
};

export default MultipleButtonItem;
